import API from "../libs/api";

const HomeworkService = {
  getHomeworkSubmissions: (homeworkId) => {
    return API.get(`/api/teacher/homework/${encodeURIComponent(homeworkId)}/submissions`);
  },
};

export default HomeworkService;
